<div class="w-full mx-auto" [ngClass]="{'max-w-screen-xl px-4 py-15 md:px-14 md:py-18': !widget.Fullwidth}"
  [ngStyle]="{'background-color': widget.Background}">
  <div class="w-full mx-auto max-w-screen-xl flex">
    <img [src]="getImageUrlFull(widget?.image?.data)" class="w-full h-full object-contain" loading="lazy" />

  </div>
</div>